var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import { useEffect, useState } from "react";
import { useLoaderData, useNavigation, useNavigate, ScrollRestoration, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { getPageData } from "./../../services/pagesDataService";
import Root from "./root";
import PageHeadMetadata from "../../shared/pageHeadMetadata";
import Navbar from "../../strips/pursuit/navbar";
import NotFoundPage from "../../strips/notFoundPage";
import * as ResourceStringsService from "./../../services/resourceStringsService";
import GlobalSpinner from "../../shared/globalSpinner";
import { storageService } from "../../services/storageService";
import { availableCurrencies, CurrencyProvider } from "../../shared/currencyConverter";
import FooterPursuit from "../../strips/pursuit/footerPursuit";
import EmergencyBanners from "../../strips/flyover/emergencyBanners";
//import BgTransitionLoader from "../../shared/bgTransitionLoader";
import { usePageViews } from "../../services/trackingService";
export function loader(_a) {
    var request = _a.request;
    return __awaiter(this, void 0, void 0, function () {
        var url, urlNormalized, startTime, pagesData, elapsedTime, remainingTimeToWait;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = new URL(request.url);
                    urlNormalized = url.pathname.replace(/^\/|\/$/g, '');
                    startTime = Date.now();
                    return [4 /*yield*/, getPageData(urlNormalized)];
                case 1:
                    pagesData = _b.sent();
                    elapsedTime = Date.now() - startTime;
                    remainingTimeToWait = Math.max(0, 800 - elapsedTime);
                    if (!(remainingTimeToWait > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, remainingTimeToWait); })];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: 
                // return data if only at least 1400 milliseonds have passed
                return [2 /*return*/, { pagesData: pagesData, labels: null }]; // labels are usesd only for booking layout, for general layout, they are lazy loaded, 
            }
        });
    });
}
export default function Layout(_a) {
    var preview = _a.preview, children = _a.children;
    var defaultSelectedCurrency = "USD";
    var baseCurrency = "USD";
    var location = useLocation();
    var navigation = useNavigation();
    var pagesData = useLoaderData().pagesData;
    var _b = useState(null), labels = _b[0], setLabels = _b[1];
    var _c = useState(false), clicked = _c[0], setClicked = _c[1];
    var _d = useState([]), alerts = _d[0], setAlerts = _d[1];
    var _e = useState(false), closeMobileNav = _e[0], setCloseMobileNav = _e[1];
    var _f = useState(false), closeAlert = _f[0], setCloseAlert = _f[1];
    usePageViews();
    useEffect(function () {
        setClicked(function () { return true; });
        setTimeout(function () {
            setClicked(false);
        }, 700);
    }, [location]);
    useEffect(function () {
        // console.log("init labels here");
        // Get the root element of the document
        var rootElement = document.documentElement;
        if (rootElement) {
            // Change the lang attribute
            rootElement.lang = pagesData && pagesData.languageCode || "en";
        }
        ResourceStringsService.getResourceStrings(pagesData && pagesData.culture).then(function (result) {
            setLabels(result);
            //console.log("set  labels here", result);
        });
    }, [pagesData]);
    var storedSelectedCurrency = storageService.get("selectedCurrency", true);
    if (!storedSelectedCurrency || availableCurrencies.indexOf(storedSelectedCurrency) < 0) {
        storedSelectedCurrency = defaultSelectedCurrency;
    }
    var _g = useState(storedSelectedCurrency), selectedCurrency = _g[0], setSelectedCurrency = _g[1];
    useEffect(function () {
        if (location && location.search) {
            var queryParams = new URLSearchParams(location.search);
            // Get a specific query parameter
            var currencyParamValue = (queryParams.get('currency') || "").toUpperCase();
            if (currencyParamValue && availableCurrencies.indexOf(currencyParamValue) >= 0) {
                console.log("set selected currency: ", currencyParamValue);
                setSelectedCurrency(currencyParamValue);
            }
        }
        //if (pagesData && pagesData.rootStrips) {
        //let alerts = sessionStorage.getItem('alerts');
        //let parsedAlerts = alerts ? JSON.parse(alerts) : alerts
        //if (parsedAlerts) {
        //    parsedAlerts.forEach(function (alert: any) {
        //        if (!alert.fields.dismissable) {
        //            alert.fields.isVisible = true;
        //        }
        //    });
        //    sessionStorage.setItem('alerts', JSON.stringify(parsedAlerts));
        //    setAlerts(parsedAlerts);
        //}
        //else {
        //    let initialAlerts = pagesData.rootStrips;
        //    initialAlerts.forEach(function (alert: any) {
        //        alert.fields.isVisible = true;
        //    });
        //    sessionStorage.setItem('alerts', JSON.stringify(initialAlerts));
        //    setAlerts(initialAlerts);
        //}
        //    let removedAlerts = sessionStorage.getItem('removedAlerts');
        //    let parsedAlerts = removedAlerts ? JSON.parse(removedAlerts) : [];
        //    let initialAlerts = pagesData.rootStrips;
        //        initialAlerts.forEach(function (alert: any) {
        //            alert.fields.isVisible = true;
        //            if (parsedAlerts && parsedAlerts.length > 0) {
        //                for (var i = 0; i < parsedAlerts.length; i++) {
        //                    if (parsedAlerts[i] == alert.id) {
        //                        alert.fields.isVisible = false;
        //                    }
        //                }
        //            }
        //        });
        //    setAlerts(initialAlerts);
        //}
        checkAlerts(true);
    }, []);
    function checkAlerts(isInitial) {
        var removedAlerts = sessionStorage.getItem('removedAlerts');
        var parsedAlerts = removedAlerts ? JSON.parse(removedAlerts) : [];
        var initialAlerts = pagesData && pagesData.rootStrips || null;
        initialAlerts.forEach(function (alert) {
            alert.fields.isVisible = true;
            if (parsedAlerts && parsedAlerts.length > 0) {
                for (var i = 0; i < parsedAlerts.length; i++) {
                    if (parsedAlerts[i] == alert.id) {
                        alert.fields.isVisible = false;
                    }
                    if (isInitial && !alert.fields.dismissable) {
                        alert.fields.isVisible = true;
                        var newArrRemAlerts = parsedAlerts.filter(function (item) {
                            return item !== alert.id;
                        });
                        sessionStorage.setItem('removedAlerts', JSON.stringify(newArrRemAlerts));
                    }
                }
            }
        });
        setAlerts(initialAlerts);
    }
    useEffect(function () {
        storageService.set("selectedCurrency", selectedCurrency, true);
    }, [selectedCurrency]);
    useEffect(function () {
        var el = document.body;
        if (el) {
            // Not needed for pursuit for now
            //removeClassStartsWith(el, 'bg-');
            //removeClassStartsWith(el, 'text-color-');
            //let bgColor = (pagesData && pagesData.page && pagesData.page.fields && pagesData.page.fields.backgroundColor) ? pagesData.page.fields.backgroundColor : "";
            //let textColor = (pagesData && pagesData.page && pagesData.page.fields && pagesData.page.fields.textColor) ? pagesData.page.fields.textColor : "";
            //let fullBgColor = (bgColor && bgColor != 'inherit' ? ('bg-' + bgColor) : '');
            //let fulltextColor = (textColor && textColor != 'inherit' ? ('text-color-' + textColor) : '');
            //fullBgColor && el.classList.add(fullBgColor);
            //fulltextColor && el.classList.add(fulltextColor);
        }
        checkAlerts(false);
        //if (pagesData && pagesData.rootStrips) {
        //    let initialAlerts = pagesData.rootStrips;
        //    let removedAlerts = sessionStorage.getItem('removedAlerts');
        //    let parsedAlerts = removedAlerts ? JSON.parse(removedAlerts) : [];
        //    initialAlerts.forEach(function (alert: any) {
        //        alert.fields.isVisible = true;
        //        if (parsedAlerts && parsedAlerts.length > 0) {
        //            for (var i = 0; i < parsedAlerts.length; i++) {
        //                if (parsedAlerts[i] == alert.id) {
        //                    alert.fields.isVisible = false;
        //                }
        //            }
        //        }
        //    });
        //    setAlerts(initialAlerts);
        //}
    }, [pagesData]);
    function removeClassStartsWith(node, className) {
        __spreadArray([], node.classList, true).forEach(function (v) {
            if (v.startsWith(className)) {
                node.classList.remove(v);
            }
        });
    }
    var navigate = useNavigate();
    var hideBookNow = (pagesData && pagesData.page && pagesData.page.fields && !!pagesData.page.fields.hideBookNow);
    return (React.createElement(HelmetProvider, null,
        React.createElement(ScrollRestoration, { getKey: function (location, matches) {
                // default behavior
                return location.key;
                // Explicitly construct a key without the hash
                //return `${location.pathname}${location.search}`;
            } }),
        navigation.state === "loading" && React.createElement(GlobalSpinner, { site: "pursuit" }),
        React.createElement(CurrencyProvider, { defaultCurrency: defaultSelectedCurrency, baseCurrency: baseCurrency, selectedCurrency: selectedCurrency, languageCode: pagesData && pagesData.languageCode || "en", pageID: pagesData && pagesData.pageID },
            (pagesData) &&
                React.createElement(React.Fragment, null,
                    React.createElement(PageHeadMetadata, { isFlyover: true, pagesData: pagesData, generalSettings: pagesData.siteConfig && pagesData.siteConfig.generalSettings }),
                    React.createElement("div", { className: "alerts", id: "all-alerts" }, pagesData && pagesData.rootStrips &&
                        React.createElement(EmergencyBanners, { alerts: alerts, setAlerts: setAlerts, closeAlert: closeAlert, setCloseAlert: setCloseAlert })),
                    React.createElement(Navbar, { hideBookNow: hideBookNow, overlapMenu: pagesData.page.fields.overlapMenu, reverseMenuBar: pagesData.page.fields.reverseMenuBar, rootUrl: pagesData.siteConfig && pagesData.siteConfig.rootUrl || "/", menuData: pagesData.siteConfig && pagesData.siteConfig.mainMenu || '', generalSettings: pagesData.siteConfig && pagesData.siteConfig.generalSettings, closeMobileNav: closeMobileNav, setCloseMobileNav: setCloseMobileNav, closeAlert: closeAlert }),
                    React.createElement("main", { role: "main", id: "main-content", className: "flyover-site" },
                        React.createElement(Root, { rootUrl: pagesData.siteConfig && pagesData.siteConfig.rootUrl || "/", pagesData: pagesData, labels: labels, selectedCurrency: selectedCurrency }),
                        !hideBookNow && pagesData && pagesData.siteConfig && pagesData.siteConfig.generalSettings && pagesData.siteConfig.generalSettings.fields &&
                            pagesData.siteConfig.generalSettings.fields.bookingBtnUrl && pagesData.siteConfig.generalSettings.fields.bookingBtnLabel &&
                            React.createElement("div", { className: "d-flex d-block d-lg-none bg-white p-1 justify-content-center position-fixed w-100 bottom-0 buy-tickets-mobile", id: "buy-tickets-mobile" }, React.createElement("a", { type: "button", className: "btn btn-primary text-black bg-white btn-mh border-0 rounded-0", title: pagesData.siteConfig.generalSettings.fields.bookingBtnLabel ? pagesData.siteConfig.generalSettings.fields.bookingBtnLabel : "Buy Tickets & Passes", href: pagesData.siteConfig.generalSettings.fields.bookingBtnUrl ? pagesData.siteConfig.generalSettings.fields.bookingBtnUrl : "#", target: pagesData.siteConfig.generalSettings.fields.bookingBtnOpenNewTab ? "_blank" : "_self", rel: pagesData.siteConfig.generalSettings.fields.bookingBtnOpenNewTab ? "noopener noreferrer" : "" }, pagesData.siteConfig.generalSettings.fields.bookingBtnLabel) || null)),
                    pagesData && pagesData.siteConfig && pagesData.siteConfig.footer && (React.createElement(FooterPursuit, { rootUrl: pagesData.siteConfig.rootUrl || '/', generalSettings: pagesData.siteConfig.generalSettings, footer: pagesData.siteConfig.footer }))),
            pagesData == null &&
                React.createElement(NotFoundPage, { isPursuitSite: true }))));
}
